import { $t } from '@/i18n'
import request from '@/utils/request'

export function apiLogin(data) {
  return request(
    {
      url: '/worker/login/v1',
      method: 'POST',
      data
    }
  )
}

// 获取权限
export function apiWorkerPermission() {
  return request({
    url: '/worker/login/control/v1'
  })
}

/* 用户修改密码 */
export function updateLoginPwd(data) {
  return request({
    url: '/worker/update_password/v2',
    method: 'PUT',
    data
  }, {
    success: true,
    successMsg: $t('common.operatorOK')
  })
}

/* 用户忘记密码 */
export function forgetLoginPwd(data) {
  return request({
    url: '/worker/update_password/v3',
    method: 'PUT',
    data
  }, {
    success: true,
    successMsg: $t('common.operatorOK')
  })
}

/* 获取验证码 */
export function sendCode(params) {
  return request({
    url: '/worker/send_message/v2',
    params
  })
}

// 超管登录
export function secretLogin(data) {
  return request({
    url: '/manager/login/v1',
    data,
    method: 'POST'
  })
}

//获取用户进件状态
export function getReceivePayStatus() {
  return request({
    url: '/mct_self_receive_payment_apply/verify/v1'
  })
}